import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { APIProvider, Map, ControlPosition } from '@vis.gl/react-google-maps';
import { styled } from '@mui/material/styles';
import { ServiceInspectionCollectionPointMarkers } from '@/components/service/map/ServiceInspectionCollectionPointMarkers.jsx';

const StyledMapBox = styled(Box)({
    '&.map-box': {
        width: '100%',
        height: 'calc(98vh - 230px)',
        overflow: 'hidden',
        borderRadius: '16px',
        '& .gm-style-iw-chr': {
            display: 'none',
        },
        '& .gm-style-iw-c': {
            padding: '0 !important',
        },
        '& .gm-style-iw-d': {
            padding: '16px',
            overflow: 'hidden !important',
        },
        '& .gm-style-iw.gm-style-iw-c': {
            padding: '10px',
        },
    },
});

export const ServiceInspectionMapView = ({ collectionPointData, googleMapsApiKey, mapId }) => {
    return (
        <StyledMapBox className='map-box'>
            <APIProvider apiKey={googleMapsApiKey} libraries={['marker']}>
                <Map
                    mapId={mapId}
                    defaultZoom={6.5}
                    defaultCenter={{ lat: 52.191111, lng: 19.355417 }}
                    gestureHandling={'greedy'}
                    disableDefaultUI
                    style={{ width: '100%', height: '100%' }}
                    fullscreenControl={true}
                    zoomControl={true}
                    options={{
                        zoomControl: true,
                        fullscreenControl: true,
                        zoomControlOptions: { position: ControlPosition.RIGHT_BOTTOM },
                        fullscreenControlOptions: { position: ControlPosition.RIGHT_BOTTOM },
                    }}
                >
                    <ServiceInspectionCollectionPointMarkers collectionPointData={collectionPointData} />
                </Map>
            </APIProvider>
        </StyledMapBox>
    );
};

ServiceInspectionMapView.propTypes = {
    collectionPointData: PropTypes.arrayOf(PropTypes.object).isRequired,
    googleMapsApiKey: PropTypes.string.isRequired,
    mapId: PropTypes.string.isRequired,
};
